import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpRequest } from "@angular/common/http";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule, ActionReducer, MetaReducer } from "@ngrx/store";

import { MatIconModule } from "@angular/material/icon";

import {
  defaultAuthOptions,
  AUTH_INTERCEPTOR_HEADER,
  AUTH_OPTIONS,
  AUTH_TOKEN_INTERCEPTOR_FILTER,
  AUTH_USER_OPTIONS,
  AuthOptions,
} from "./auth.options";

import { AuthLayoutComponent } from "./components/auth.component";
import { AuthHeaderComponent } from "./components/auth-header/auth-header.component";
import { AuthFooterComponent } from "./components/auth-footer/auth-footer.component";

import { AuthBlockComponent } from "./components/auth-block/auth-block.component";
import { LoginComponent } from "./components/login/vta.login.component";
import { RegisterComponent } from "./components/register/vta.register.component";
import { LogoutComponent } from "./components/logout/logout.component";
import { RequestPasswordComponent } from "./components/request-password/vta.request-password.component";
import { ButtonModule } from "@syncfusion/ej2-angular-buttons";
import { TextBoxModule } from "@syncfusion/ej2-angular-inputs";
import { localStorageSync } from "ngrx-store-localstorage";

import { ApiService } from "./services/api.service";
import { AuthenticationEffects } from "./store/effects/authentication.effects";
import { reducers } from "./store/app.states";
import { deepExtend } from "./helpers";
import { ResetPasswordComponent } from "./components/reset-password/vta.reset-password.component";
import { VerifyUserComponent } from "./components/verify-user/vta.verify-user.component";
import { ApproveRequestComponent } from "./components/approve-request/vta.approve-request.component";
import { ProgressButtonModule } from "@syncfusion/ej2-angular-splitbuttons";
import { VerifyEmailComponent } from "./components/verify-email/vta.verify-email.component";

export function authOptionsFactory(options) {
  return deepExtend(defaultAuthOptions, options);
}

export function authNoOpInterceptorFilter(req: HttpRequest<any>): boolean {
  return true;
}

export function localStorageSyncReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return localStorageSync({ keys: ["authentication"], rehydrate: true })(
    reducer
  );
}
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    RouterModule,
    FormsModule,
    EffectsModule.forRoot([AuthenticationEffects]),
    StoreModule.forRoot(reducers, { metaReducers }),
    TextBoxModule,
    ReactiveFormsModule,
    ButtonModule,
    ProgressButtonModule,
  ],
  declarations: [
    AuthLayoutComponent,
    AuthBlockComponent,
    AuthHeaderComponent,
    AuthFooterComponent,
    LoginComponent,
    RegisterComponent,
    RequestPasswordComponent,
    ResetPasswordComponent,
    VerifyUserComponent,
    VerifyEmailComponent,
    LogoutComponent,
    ApproveRequestComponent,
  ],
  exports: [
    AuthLayoutComponent,
    AuthBlockComponent,
    AuthHeaderComponent,
    AuthFooterComponent,
    LoginComponent,
    RegisterComponent,
    RequestPasswordComponent,
    ResetPasswordComponent,
    VerifyUserComponent,
    VerifyEmailComponent,
    LogoutComponent,
  ],
})
export class AuthModule {
  static forRoot(
    authOptions?: AuthOptions
  ): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        { provide: AUTH_USER_OPTIONS, useValue: authOptions },
        {
          provide: AUTH_OPTIONS,
          useFactory: authOptionsFactory,
          deps: [AUTH_USER_OPTIONS],
        },
        { provide: AUTH_INTERCEPTOR_HEADER, useValue: "Authorization" },
        {
          provide: AUTH_TOKEN_INTERCEPTOR_FILTER,
          useValue: authNoOpInterceptorFilter,
        },
        ApiService,
      ],
    };
  }
}
